import { useEffect, useState } from 'react';
import { micAccess, type MicAccess } from './recorder';

let known: MicAccess | null = null;

/** Whether the microphone can be used here: unsupported, blocked, or worth offering. */
export function useMicAccess(): MicAccess | null {
  const [access, setAccess] = useState<MicAccess | null>(known);
  useEffect(() => {
    let live = true;
    micAccess().then((a) => {
      known = a;
      if (live) setAccess(a);
    });
    return () => {
      live = false;
    };
  }, []);
  return access;
}

let declined = false;

/**
 * Remembers for this visit that the microphone can't or won't be used, so every card doesn't
 * offer it again. A real refusal by the browser also updates what is known about access.
 */
export function noteMicProblem(problem: 'denied' | 'unsupported' | 'failed' | 'declined' | 'insecure') {
  if (problem === 'denied' || problem === 'unsupported') known = problem;
  declined = true;
}

export function micDeclined(): boolean {
  return declined;
}

/** The learner wants to record again after choosing not to. */
export function undoMicDeclined() {
  declined = false;
}

/**
 * Whether to offer the record button. Only where recording can't work at all (no secure
 * connection, no recorder in this browser) or the learner said "not now" is it replaced; a
 * microphone the browser reports as blocked still gets the button, because tapping it may ask again.
 */
export function canOfferRecording(access: MicAccess | null, refused: boolean): boolean {
  return !refused && access !== 'unsupported' && access !== 'insecure';
}
